import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { routeNames } from '../../../util/Constants';
import CartFormComponent from '../CartFormComponent';

function CartForm({
  isShowGiftCodeInput,
  closeModal,
  isDesktop,
  showCheckoutButton,
}) {
  const navigate = useNavigate();

  return (
    <CartFormComponent
      isDesktop={isDesktop}
      isShowGiftCodeInput={isShowGiftCodeInput}
      showCheckoutButton={showCheckoutButton}
      onCheckoutReady={() => {
        // Called only after the owning hook's current-operation check; do not
        // defer navigation to another render where the context may change.
        closeModal();
        navigate(routeNames.checkout);
      }}
    />
  );
}

CartForm.propTypes = {
  isShowGiftCodeInput: PropTypes.bool,
  closeModal: PropTypes.func,
  isDesktop: PropTypes.bool,
  showCheckoutButton: PropTypes.bool,
};

CartForm.defaultProps = {
  isShowGiftCodeInput: false,
  showCheckoutButton: true,
  isDesktop: false,
  closeModal: () => null,
};

export default CartForm;
